export const APIImobsaleUrl = 'https://api.estafor.com.br/v1/venda/';
export const APICadimo5Url = 'https://cadimo.imobsoft.com.br:8052/';
export const TokenAPI = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkFyZWEgQ2xpZW50ZSBJbW9ic29mdCIsImlhdCI6MTUxNjIzOTAyMn0.PWkJYMxddFlicDUSLOFda2S_wpxdfUnExMv-HuNrES4';
export const TokenCadimo5Api = btoa('estafor:B6Uoqua9TYo1wS1i');
export const TokenConta = 'B6Uoqua9TYo1wS1i';
export const MODALIDADE_ALUGUEL = 'aluguel';
export const MODALIDADE_VENDA = 'venda';
export const METODOS = {
    "aluguel" : {
        'busca': 'BuscaImoveis',
        'tipos': 'CarregaTipos',
        'tipos-finalidade': 'CarregaTiposPorFinalidade',
        'destaques': 'CarregaDestaques',
        'detalhes': 'CarregaDetalhes/',
        'destaquesEspeciais': 'CarregaDestaques',
        'caracteristicas': 'CarregaCaracteristicas',
        'caracteristicasCondominio': 'CarregaCaracteristicasCondominio',
        'buscaEndereco': 'CarregaBairrosCidades',
    },
    "venda" : {
        'busca': 'imoveis',
        'tipos': 'tiposImoveisOptions',
        'tipos-finalidade': 'tiposImoveisOptions',
        'destaques': 'destaques',
        'detalhes': 'detalhes?codigo=',
        'destaquesEspeciais': 'destaqueEspecial',
        'caracteristicas': 'caracteristicasOptions',
        'caracteristicasCondominio': 'caracteristicasCondominioOptions',
        'buscaEndereco': 'buscaEndereco?palavra=',
    }
};